export default "__VITE_ASSET__CzREzyD7__"